import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["cstBlock", "cstInput", "cstBadge", "drssBlock", "drssLimitedBlock"];
  static values = { threshold: Number };

  toggleOctCst(event) {
    const gradable = event.target.value !== "ungradable";
    this.cstBlockTarget.classList.toggle("hidden", !gradable);
    if (!gradable) this.cstInputTarget.value = "";
  }

  updateCstGate() {
    const threshold = this.hasThresholdValue ? this.thresholdValue : 325;
    const value = parseFloat(this.cstInputTarget.value);
    const badge = this.cstBadgeTarget;
    if (isNaN(value)) {
      badge.classList.add("hidden");
      return;
    }
    badge.classList.remove("hidden");
    if (value <= threshold) {
      badge.textContent = "✓ Within threshold";
      badge.className = "text-xs font-semibold px-2 py-1 rounded bg-green-100 text-green-800";
    } else {
      badge.textContent = "⚠ Above threshold";
      badge.className = "text-xs font-semibold px-2 py-1 rounded bg-amber-100 text-amber-800";
    }
  }

  connect() {
    this.syncDrssVisibility();
  }

  syncDrssVisibility() {
    if (!this.hasDrssBlockTarget) return;

    const checked = this.element.querySelector('input[name="image_gradability"]:checked');
    const gradable = checked && checked.value === "gradable";
    this.drssBlockTarget.classList.toggle("hidden", !gradable);
  }

  toggleDrss(event) {
    const gradable = event.target.value === "gradable";
    this.drssBlockTarget.classList.toggle("hidden", !gradable);
  }

  toggleDrssLimited(event) {
    const gradable = event.target.value === "gradable";
    this.drssLimitedBlockTarget.classList.toggle("hidden", !gradable);
  }
}
